import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { Link, useHistory, useParams } from 'react-router-dom';
import { data } from 'autoprefixer';

const ListDashboard = () => {
  const [dataLowongan, setDataLowongan] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetchStatus, setFetchStatus] = useState(true);
  const [currentId, setCurrentId] = useState(-1);
  let history = useHistory();
  let { slug } = useParams();

  const [input, setInput] = useState({
    title: '',
    job_description: '',
    job_qualification: '',
    job_type: '',
    job_tenure: '',
    job_status: 0,
    company_name: '',
    company_image_url: '',
    company_city: '',
    salary_min: 0,
    salary_max: 0,
  });

  useEffect(() => {
    let fetchData = async () => {
      try {
        setLoading(true);
        let { data } = await axios.get(
          `https://dev-example.sanbercloud.com/api/job-vacancy`
        );
        setLoading(false);

        let result = data.data;

        setDataLowongan([...result]);
      } catch (error) {
        setTimeout(() => {
          alert('Maaf internet Anda bermasalah');
        }, 5000);
      }
    };

    if (fetchStatus) {
      fetchData();
      setFetchStatus(false);
    }
  }, [fetchStatus, setFetchStatus]);

  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState({
    job_type: '',
    company_name: '',
    company_city: '',
  });

  const handleChangeSearch = (event) => {
    setSearch(event.target.value);
  };

  const handleChangeFilter = (event) => {
    let { name, value } = event.target;

    setFilter({ ...filter, [name]: value });
  };

  const handleSearch = (event) => {
    event.preventDefault();

    axios
      .get('https://dev-example.sanbercloud.com/api/job-vacancy')
      .then(({ data }) => {
        let fetchResult = data.data;

        let result = fetchResult.filter((res) => {
          return Object.values(res)
            .join('')
            .toLowerCase()
            .includes(search.toLowerCase());
        });

        setDataLowongan([...result]);
        setSearch('');
      });
  };

  const handleFilter = (event) => {
    event.preventDefault();
    axios
      .get('https://dev-example.sanbercloud.com/api/job-vacancy')
      .then(({ data }) => {
        let fetchResult = data.data;

        let result = fetchResult.filter((res) => {
          return (
            res.company_city.toLowerCase() ===
              filter.company_city.toLowerCase() ||
            res.job_type.toLowerCase() === filter.job_type.toLowerCase() ||
            res.company_name.toLowerCase() === filter.company_name.toLowerCase()
          );
        });

        setDataLowongan([...result]);
        setSearch('');
      });
  };

  const handleEdit = (event) => {
    let dataId = parseInt(event.target.value);

    console.log(dataId);
    axios
      .get(`https://dev-example.sanbercloud.com/api/job-vacancy/${dataId}`)
      .then((res) => {
        // console.log(res.data);
        let result = res.data;
        setInput({ ...result });
        setFetchStatus(true);
        // history.push(`/dashboard/list-job-vacancy/form/edit/${dataId}`);
        let editValue = res.data;
        setInput(editValue);
        setCurrentId(event.target.value);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDelete = (event) => {
    let dataId = parseInt(event.target.value);

    axios
      .delete(`https://dev-example.sanbercloud.com/api/job-vacancy/${dataId}`, {
        headers: { Authorization: 'Bearer ' + Cookies.get('token') },
      })
      .then((res) => {
        setFetchStatus(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChange = (event) => {
    let { name, value } = event.target;
    setInput({ ...input, [name]: value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    let {
      title,
      job_description,
      job_qualification,
      job_type,
      job_tenure,
      job_status,
      company_name,
      company_image_url,
      company_city,
      salary_min,
      salary_max,
    } = input;

    if (currentId === -1) {
      axios
        .post(
          `https://dev-example.sanbercloud.com/api/job-vacancy`,
          {
            title,
            job_description,
            job_qualification,
            job_type,
            job_tenure,
            job_status,
            company_name,
            company_image_url,
            company_city,
            salary_min,
            salary_max,
          },
          {
            headers: { Authorization: 'Bearer ' + Cookies.get('token') },
          }
        )
        .then(({ data }) => {
          setFetchStatus(true);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      axios
        .put(
          `https://dev-example.sanbercloud.com/api/job-vacancy/${currentId}`,
          {
            title: input.title,
            job_description: input.job_description,
            job_qualification: input.job_qualification,
            job_type: input.job_type,
            job_tenure: input.job_tenure,
            job_status: input.job_status,
            company_name: input.company_name,
            company_image_url: input.company_image_url,
            company_city: input.company_city,
            salary_min: input.salary_min,
            salary_max: input.salary_max,
          },
          {
            headers: { Authorization: 'Bearer ' + Cookies.get('token') },
          }
        )
        .then((res) => {
          setFetchStatus(true);
          let data = dataLowongan.find((el) => el.id === currentId);
          title = data.title;
          job_description = data.job_description;
          job_qualification = data.job_qualification;
          job_type = data.job_type;
          job_tenure = data.job_tenure;
          job_status = data.job_status;
          company_name = data.company_name;
          company_image_url = data.company_image_url;
          company_city = data.company_city;
          salary_min = data.salary_min;
          salary_max = data.salary_max;
          setDataLowongan([...dataLowongan]);
        });
    }

    setInput({
      title: '',
      job_description: '',
      job_qualification: '',
      job_type: '',
      job_tenure: '',
      job_status: 0,
      company_name: '',
      company_image_url: '',
      company_city: '',
      salary_min: 0,
      salary_max: 0,
    });

    setCurrentId(-1);
  };

  return (
    <>
      <div className="z-40 items-center py-6 ml-1">
        <form
          onSubmit={handleFilter}
          className="flex flex-col justify-center w-3/4 max-w-sm ml-32 md:flex-row md:w-full md:space-x-3 md:space-y-0"
        >
          <input
            name="job_type"
            value={filter.job_type}
            onChange={handleChangeFilter}
            type="text"
            className="px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none w-44 focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
            placeholder="Job type..."
          />
          <input
            name="company_city"
            value={filter.company_city}
            onChange={handleChangeFilter}
            type="text"
            className="px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none w-44 focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
            placeholder="Company city..."
          />
          <input
            name="company_name"
            value={filter.company_name}
            onChange={handleChangeFilter}
            type="text"
            className="px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none w-44 focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
            placeholder="Company name..."
          />
          <input
            value={'Filter'}
            className="flex-shrink-0 px-4 py-2 text-base font-semibold text-white bg-purple-600 rounded-lg shadow-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-purple-200"
            type="submit"
          />
        </form>
        <form
          onSubmit={handleSearch}
          className="flex flex-col justify-center w-3/4 max-w-sm mt-6 mb-4 md:flex-row md:w-full md:space-x-3 md:space-y-0"
        >
          <input
            value={search}
            onChange={handleChangeSearch}
            type="text"
            className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
            placeholder="Search Job Name..."
          />
          <input
            value={'Search'}
            className="flex-shrink-0 px-4 py-2 text-base font-semibold text-white bg-purple-600 rounded-lg shadow-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-purple-200"
            type="submit"
          />
        </form>
        <button
          onClick={() => {
            setFetchStatus(true);
          }}
          value={'Search'}
          className="flex-shrink-0 px-4 py-2 mt-4 text-base font-semibold text-white bg-red-600 rounded-lg shadow-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-red-200"
          type="submit"
        >
          Reset Filter
        </button>
        <Link
          to="/dashboard/list-job-vacancy/form/create"
          value={'Search'}
          className="flex-shrink-0 px-4 py-2 mt-4 text-base font-semibold text-white bg-green-600 rounded-lg shadow-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 focus:ring-offset-green-200"
          type="submit"
        >
          Create Data
        </Link>
        {/* <Table className="py-10" columns={columns} dataSource={data} /> */}

        <div className="container px-4 mx-auto sm:px-8">
          <div className="py-8">
            <div className="px-4 py-4 -mx-4 overflow-x-auto sm:-mx-8 sm:px-8">
              <div className="inline-block min-w-full overflow-hidden rounded-lg shadow">
                <table className="min-w-full leading-normal">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="px-5 py-3 text-sm font-normal text-left text-gray-800 uppercase bg-white border-b border-gray-200"
                      >
                        Title
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 text-sm font-normal text-left text-gray-800 uppercase bg-white border-b border-gray-200"
                      >
                        Job Description
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 text-sm font-normal text-left text-gray-800 uppercase bg-white border-b border-gray-200"
                      >
                        Job Qualification
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 text-sm font-normal text-left text-gray-800 uppercase bg-white border-b border-gray-200"
                      >
                        Job Type
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 text-sm font-normal text-left text-gray-800 uppercase bg-white border-b border-gray-200"
                      >
                        Job Tenure
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 text-sm font-normal text-left text-gray-800 uppercase bg-white border-b border-gray-200"
                      >
                        Job Status
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 text-sm font-normal text-left text-gray-800 uppercase bg-white border-b border-gray-200"
                      >
                        Company Name
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 text-sm font-normal text-left text-gray-800 uppercase bg-white border-b border-gray-200"
                      >
                        Company Image Url
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 text-sm font-normal text-left text-gray-800 uppercase bg-white border-b border-gray-200"
                      >
                        Company City
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 text-sm font-normal text-left text-gray-800 uppercase bg-white border-b border-gray-200"
                      >
                        Salary Min
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 text-sm font-normal text-left text-gray-800 uppercase bg-white border-b border-gray-200"
                      >
                        Salary Max
                      </th>
                      <th
                        scope="col"
                        className="px-20 py-3 text-sm font-normal text-left text-gray-800 uppercase bg-white border-b border-gray-200"
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataLowongan.map((res) => {
                      return (
                        <>
                          <tr>
                            <td className="px-5 py-5 text-sm bg-white border-b border-gray-200">
                              <p className="text-gray-900 whitespace-no-wrap">
                                {res.title}
                              </p>
                            </td>
                            <td className="px-5 py-5 text-sm bg-white border-b border-gray-200">
                              <p className="text-gray-900 whitespace-no-wrap">
                                {res.job_description}
                              </p>
                            </td>
                            <td className="px-5 py-5 text-sm bg-white border-b border-gray-200">
                              <p className="text-gray-900 whitespace-no-wrap">
                                {res.job_qualification}
                              </p>
                            </td>
                            <td className="px-5 py-5 text-sm bg-white border-b border-gray-200">
                              <p className="text-gray-900 whitespace-no-wrap">
                                {res.job_type}
                              </p>
                            </td>
                            <td className="px-5 py-5 text-sm bg-white border-b border-gray-200">
                              <p className="text-gray-900 whitespace-no-wrap">
                                {res.job_tenure}
                              </p>
                            </td>
                            <td className="px-5 py-5 text-sm bg-white border-b border-gray-200">
                              <p className="text-gray-900 whitespace-no-wrap">
                                {res.job_status}
                              </p>
                            </td>
                            <td className="px-5 py-5 text-sm bg-white border-b border-gray-200">
                              <p className="text-gray-900 whitespace-no-wrap">
                                {res.company_name}
                              </p>
                            </td>
                            <td className="px-5 py-5 text-sm bg-white border-b border-gray-200">
                              {/*eslint-disable-next-line jsx-a11y/alt-text */}
                              <img
                                src={res.company_image_url}
                                className="text-gray-900 whitespace-no-wrap"
                              />
                            </td>
                            <td className="px-5 py-5 text-sm bg-white border-b border-gray-200">
                              <p className="text-gray-900 whitespace-no-wrap">
                                {res.company_city}
                              </p>
                            </td>
                            <td className="px-5 py-5 text-sm bg-white border-b border-gray-200">
                              <p className="text-gray-900 whitespace-no-wrap">
                                {res.salary_min}
                              </p>
                            </td>
                            <td className="px-5 py-5 text-sm bg-white border-b border-gray-200">
                              <p className="text-gray-900 whitespace-no-wrap">
                                {res.salary_max}
                              </p>
                            </td>
                            <td className="px-5 py-5 text-sm bg-white border-b border-gray-200 ">
                              <button
                                // to={`/dashboard/list-job-vacancy/form/edit/${res.id}`}
                                onClick={handleEdit}
                                value={res.id}
                                className="px-4 py-2 bg-blue-300 rounded-md hover:bg-blue-500"
                              >
                                Edit
                              </button>
                              <button
                                onClick={handleDelete}
                                value={res.id}
                                className="px-4 py-2 ml-6 bg-red-300 rounded-md hover:bg-red-500"
                              >
                                Hapus
                              </button>
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </table>
                <div className="flex flex-col items-center px-5 py-5 bg-white xs:flex-row xs:justify-between">
                  <div className="flex items-center">
                    <button
                      type="button"
                      className="w-full p-4 text-base text-gray-600 bg-white border rounded-l-xl hover:bg-gray-100"
                    >
                      <svg
                        width="9"
                        fill="currentColor"
                        height="8"
                        className=""
                        viewBox="0 0 1792 1792"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M1427 301l-531 531 531 531q19 19 19 45t-19 45l-166 166q-19 19-45 19t-45-19l-742-742q-19-19-19-45t19-45l742-742q19-19 45-19t45 19l166 166q19 19 19 45t-19 45z"></path>
                      </svg>
                    </button>
                    <button
                      type="button"
                      className="w-full px-4 py-2 text-base text-indigo-500 bg-white border-t border-b hover:bg-gray-100 "
                    >
                      1
                    </button>
                    <button
                      type="button"
                      className="w-full px-4 py-2 text-base text-gray-600 bg-white border hover:bg-gray-100"
                    >
                      2
                    </button>
                    <button
                      type="button"
                      className="w-full px-4 py-2 text-base text-gray-600 bg-white border-t border-b hover:bg-gray-100"
                    >
                      3
                    </button>
                    <button
                      type="button"
                      className="w-full px-4 py-2 text-base text-gray-600 bg-white border hover:bg-gray-100"
                    >
                      4
                    </button>
                    <button
                      type="button"
                      className="w-full p-4 text-base text-gray-600 bg-white border-t border-b border-r rounded-r-xl hover:bg-gray-100"
                    >
                      <svg
                        width="9"
                        fill="currentColor"
                        height="8"
                        viewBox="0 0 1792 1792"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M1363 877l-742 742q-19 19-45 19t-45-19l-166-166q-19-19-19-45t19-45l531-531-531-531q-19-19-19-45t19-45l166-166q19-19 45-19t45 19l742 742q19 19 19 45t-19 45z"></path>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container flex w-full m-auto">
        <form
          onSubmit={handleSubmit}
          className="w-3/4 m-auto bg-white border rounded-lg shadow-2xl"
        >
          <div className="px-4 py-8 sm:px-10">
            <div className="relative mt-6">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300"></div>
              </div>
              <div className="relative flex justify-center text-sm leading-5">
                <span className="px-2 text-xl font-semibold text-gray-400 bg-white">
                  Formulir Input Data
                </span>
              </div>
            </div>
            <div className="mt-14">
              <div className="grid w-full space-y-6 gap-y-6">
                <div className="w-full">
                  <div className="relative border border-gray-300 rounded-lg">
                    <input
                      required
                      value={input.title}
                      onChange={handleChange}
                      name="title"
                      type="text"
                      className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                      placeholder="Title"
                    />
                  </div>
                </div>
                <div className="w-full">
                  <div className="relative border border-gray-300 rounded-lg">
                    <input
                      required
                      value={input.job_description}
                      onChange={handleChange}
                      name="job_description"
                      type="text"
                      className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                      placeholder="Job Description"
                    />
                  </div>
                </div>
                <div className="w-full">
                  <div className="relative border border-gray-300 rounded-lg">
                    <input
                      required
                      value={input.job_qualification}
                      onChange={handleChange}
                      name="job_qualification"
                      type="text"
                      className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                      placeholder="Job Qualification"
                    />
                  </div>
                </div>
                <div className="w-full">
                  <div className="relative border border-gray-300 rounded-lg">
                    <input
                      required
                      value={input.job_type}
                      onChange={handleChange}
                      name="job_type"
                      type="text"
                      className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                      placeholder="Job Type"
                    />
                  </div>
                </div>
                <div className="w-full">
                  <div className="relative border border-gray-300 rounded-lg">
                    <input
                      required
                      value={input.job_tenure}
                      onChange={handleChange}
                      name="job_tenure"
                      type="text"
                      className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                      placeholder="Job Tenure"
                    />
                  </div>
                </div>
                <div className="w-full">
                  <div className="relative border border-gray-300 rounded-lg">
                    <input
                      required
                      value={input.job_status}
                      onChange={handleChange}
                      name="job_status"
                      type="text"
                      className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                      placeholder="Job Status"
                    />
                  </div>
                </div>
                <div className="w-full">
                  <div className="relative border border-gray-300 rounded-lg">
                    <input
                      required
                      value={input.company_name}
                      onChange={handleChange}
                      name="company_name"
                      type="text"
                      className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                      placeholder="Company Name"
                    />
                  </div>
                </div>
                <div className="w-full">
                  <div className="relative border border-gray-300 rounded-lg">
                    <input
                      required
                      value={input.company_image_url}
                      onChange={handleChange}
                      name="company_image_url"
                      type="text"
                      className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                      placeholder="Company Image Url"
                    />
                  </div>
                </div>
                <div className="w-full">
                  <div className="relative border border-gray-300 rounded-lg">
                    <input
                      required
                      value={input.company_city}
                      onChange={handleChange}
                      name="company_city"
                      type="text"
                      className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                      placeholder="Company City"
                    />
                  </div>
                </div>
                <div className="w-full">
                  <div className="relative border border-gray-300 rounded-lg">
                    <input
                      required
                      value={input.salary_min}
                      onChange={handleChange}
                      name="salary_min"
                      type="number"
                      className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                      placeholder="Salary Min"
                    />
                  </div>
                </div>
                <div className="w-full">
                  <div className="relative border border-gray-300 rounded-lg">
                    <input
                      required
                      value={input.salary_max}
                      onChange={handleChange}
                      name="salary_max"
                      type="number"
                      className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                      placeholder="Salary Max"
                    />
                  </div>
                </div>
                <div>
                  <span className="block w-full mb-10 rounded-md shadow-sm">
                    <button
                      type="submit"
                      className="w-full px-4 py-2 text-base font-semibold text-center text-white transition duration-200 ease-in bg-blue-500 rounded-lg shadow-md hover:bg-blue-700 focus:ring-blue-500 focus:ring-offset-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2 "
                    >
                      Kirim
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default ListDashboard;
